<template>
    <div>
        <!-- 侧边栏 -->
        <sider-list-1 ref="side"></sider-list-1>
        <!-- 右侧主要内容 -->
        <div class="home-content" ref="content">
            <router-view></router-view>
        </div>
        <infoAction  ref="agreementCom2"  @suerAgree="suerAgree2" :type="4" v-if="isShowAgreement2"/>
    </div>
</template>

<script>
// 左侧侧边栏
import SiderList1 from "./siderList1";
import infoAction from "../../download/infoAction.vue"

export default {
    name: "barManager",
    components: {
        SiderList1,
        infoAction
    },
    data(){
        return {
            isShowAgreement2:true
        }
    },
    mounted() {
        // this.$domFn.addAnimateClass(this.$refs.content, 'animated zoomInLeft')
        this.$refs.agreementCom2.isShowTxt = true
    },
    methods:{
        suerAgree2(){
            this.isShowAgreement2 = false
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$refs.side.init();
        });
    }
};
</script>

<style lang="scss" scoped>
.home-content {
    position: absolute;
    // min-width: 940px;
    min-width: 1180px;
    left: 200px;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    overflow-y: auto;
}
</style>
